module.exports = __webpack_public_path__ + "static/media/logo_red_vertical.e0e8297c.png";